export default __webpack_public_path__ + "media/images/25-2c348385c065300168e85c610b5f4a78.jpg";